export const hebrewLetterToValue = {
  'א': 1, 'ב': 2, 'ג': 3, 'ד': 4, 'ה': 5, 'ו': 6, 'ז': 7, 'ח': 8, 'ט': 9,
  'י': 10, 'כ': 20, 'ך': 20, 'ל': 30, 'מ': 40, 'ם': 40, 'נ': 50, 'ן': 50, 'ס': 60,
  'ע': 70, 'פ': 80, 'ף': 80, 'צ': 90, 'ץ': 90, 'ק': 100, 'ר': 200, 'ש': 300, 'ת': 400
};

export function convertHebrewNumeralToken(token) {
  if (token === undefined || token === null) {
    return 0;
  }
  let input = String(token);
  let thousands = 0;
  const thousandsMatch = input.match(/^([אבגדהוזחטיכלמנסעפצקרשת])׳/);
  if (thousandsMatch !== null) {
    const letter = thousandsMatch[1];
    const base = hebrewLetterToValue[letter];
    if (typeof base === 'number') {
      thousands = base * 1000;
    }
    input = input.replace(/^([אבגדהוזחטיכלמנסעפצקרשת])׳/, '');
  }
  const cleaned = input.replace(/["״׳']/g, '');
  let sum = 0;
  for (let i = 0; i < cleaned.length; i = i + 1) {
    const ch = cleaned[i];
    const val = hebrewLetterToValue[ch];
    if (typeof val === 'number') {
      sum = sum + val;
    }
  }
  return thousands + sum;
}

export function hebrewTextToNumber(text) {
  if (text === undefined || text === null) {
    return 0;
  }
  return convertHebrewNumeralToken(String(text));
}

export function replaceHebrewNumeralsWithDigits(value) {
  if (value === undefined || value === null) {
    return '';
  }
  if (typeof value !== 'string') {
    return String(value);
  }
  const pattern = /[אבגדהוזחטיכלמנסעפצקרשת]["״׳'][אבגדהוזחטיכלמנסעפצקרשת"״׳']*/g;
  return value.replace(pattern, (match) => String(convertHebrewNumeralToken(match)));
}

export function numberToHebrewLetters(n) {
  const num = Number(n);
  if (isNaN(num) === true) {
    return '';
  }
  let value = num;
  if (value >= 5000 && value < 6000) {
    value = value - 5000;
  }
  let result = '';
  const hundreds = [400, 300, 200, 100];
  const hundredsLetters = ['ת', 'ש', 'ר', 'ק'];
  for (let i = 0; i < hundreds.length; i = i + 1) {
    while (value >= hundreds[i]) {
      result = result + hundredsLetters[i];
      value = value - hundreds[i];
    }
  }
  const tensValues = [90, 80, 70, 60, 50, 40, 30, 20, 10];
  const tensLetters = ['צ', 'פ', 'ע', 'ס', 'נ', 'מ', 'ל', 'כ', 'י'];
  for (let i = 0; i < tensValues.length; i = i + 1) {
    if (value >= tensValues[i]) {
      result = result + tensLetters[i];
      value = value - tensValues[i];
    }
  }
  if (value === 15) {
    result = result + 'טו';
    value = 0;
  } else if (value === 16) {
    result = result + 'טז';
    value = 0;
  }
  const units = ['א', 'ב', 'ג', 'ד', 'ה', 'ו', 'ז', 'ח', 'ט'];
  if (value >= 1 && value <= 9) {
    result = result + units[value - 1];
    value = 0;
  }
  if (result.length >= 2) {
    const lastChar = result.slice(-1);
    const head = result.slice(0, -1);
    return head + '״' + lastChar;
  } else if (result.length === 1) {
    return result + '׳';
  }
  return '';
}

export function isHebrewLeapYear(year) {
  const y = Number(year);
  if (isNaN(y) === true) {
    return false;
  }
  const r = y % 19;
  return r === 0 || r === 3 || r === 6 || r === 8 || r === 11 || r === 14 || r === 17;
}

export function getHebrewMonthName(month, year) {
  const m = Number(month);
  const y = Number(year);
  const leap = isHebrewLeapYear(y);
  if (leap === true) {
    if (m === 1) return 'תשרי';
    if (m === 2) return 'חשוון';
    if (m === 3) return 'כסלו';
    if (m === 4) return 'טבת';
    if (m === 5) return 'שבט';
    if (m === 6) return 'אדר א׳';
    if (m === 7) return 'אדר ב׳';
    if (m === 8) return 'ניסן';
    if (m === 9) return 'אייר';
    if (m === 10) return 'סיוון';
    if (m === 11) return 'תמוז';
    if (m === 12) return 'אב';
    if (m === 13) return 'אלול';
  } else {
    if (m === 1) return 'תשרי';
    if (m === 2) return 'חשוון';
    if (m === 3) return 'כסלו';
    if (m === 4) return 'טבת';
    if (m === 5) return 'שבט';
    if (m === 6) return 'אדר';
    if (m === 7) return 'ניסן';
    if (m === 8) return 'אייר';
    if (m === 9) return 'סיוון';
    if (m === 10) return 'תמוז';
    if (m === 11) return 'אב';
    if (m === 12) return 'אלול';
  }
  return '';
}



